//
// Scripts
//

import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import ScrollSpy from 'bootstrap/js/dist/scrollspy';
import Toast     from 'bootstrap/js/dist/toast';


// Activate Bootstrap scrollspy on the main nav element
const sideNav = document.body.querySelector('#sidenav');
if (sideNav) {
    new ScrollSpy(document.body, {
        target: '#sidenav',
        offset: 74,
    });
};

// Collapse responsive navbar when toggler is visible
const navbar = document.body.querySelector('#navbarResponsive');
const navbarToggler = document.body.querySelector('.navbar-toggler');

const navBrand = [].slice.call(
    document.querySelectorAll('.navbar-brand')
);
const responsiveNavItems = [].slice.call(
    document.querySelectorAll('#navbarResponsive .nav-link')
);
[...navBrand, ...responsiveNavItems].map(function (responsiveNavItem) {
    responsiveNavItem.addEventListener('click', () => {
        if (window.getComputedStyle(navbarToggler).display !== 'none' && navbar.classList.contains('show')) {
            navbarToggler.click();
        }
    });
});

// Hide Hash Fragment when scrolling to the top
// document.addEventListener('scroll', () => {
//     if (window.scrollY === 0) {
//         window.history.replaceState(null, null, ' ');
//     }
// });

// Show E-mail Toast
const mailToast = document.body.querySelector('#about #mail-toast .toast');
const bsMailToast = new Toast(mailToast);

function copyMail() {
    console.log('copied');
    navigator.clipboard.writeText(atob('bWFpbHRvOkN4UmVTQHBSb1RvTi5tRQ==')
        .toLowerCase()
        .replace('@', '+website@')
        .substring(7)
    );
    mailToast.children[0].textContent = 'E-mail Address Copied!';
    bsMailToast.show();
}

function copyFingerprint() {
    navigator.clipboard.writeText('8bafa14b1a6a2f7d8912ea197e769bbd430c2179');
    mailToast.children[0].textContent = 'PGP Fingerprint Copied!';
    bsMailToast.show();
}

// document.getElementById('copy-mail').addEventListener('click', copyMail);
// document.getElementById('copy-fp').addEventListener('click', copyFingerprint);
document.getElementById('copy2-mail', () => {console.log("copy2-mail copied")}).addEventListener('click', copyMail);
document.getElementById('copy2-fp').addEventListener('click', copyFingerprint);